import { render, staticRenderFns } from "./teacherDetail.vue?vue&type=template&id=29b7492e"
import script from "./teacherDetail.vue?vue&type=script&lang=js"
export * from "./teacherDetail.vue?vue&type=script&lang=js"
import style0 from "./teacherDetail.vue?vue&type=style&index=0&id=29b7492e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports